export enum AudioFormatExtensions {
    'audio/webm' = '.weba',
    'audio/mp4' = '.m4a',
}
